import { render, staticRenderFns } from "./table-wrapper.vue?vue&type=template&id=f844b288"
import script from "./table-wrapper.vue?vue&type=script&lang=js"
export * from "./table-wrapper.vue?vue&type=script&lang=js"
import style0 from "./table-wrapper.vue?vue&type=style&index=0&id=f844b288&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports